import React, { Fragment, FunctionComponent, ReactElement } from "react";

import { getSkeletonPercentageWidthByIndex, Skeleton } from "@multiweb/reactComponents";
import { bridge } from "@multiweb/reactCore/bridge";
import { bemClassNames } from "@multiweb/reactUtils";

const { generateUUID } = bridge;

export type DropdownSkeletonItem = {
    skeletonCount?: number;
};

const className = bemClassNames("dropdown-skeleton-item");

export const DropdownSkeletonItem: FunctionComponent<DropdownSkeletonItem> = ({
    skeletonCount = 1,
}) => {
    const skeletons: ReactElement[] = [];

    for (let i = 0; i < skeletonCount; i++) {
        skeletons.push(
            <Fragment key={`fragment-${i}`}>
                <Skeleton key={generateUUID()} />
                <Skeleton key={generateUUID()} width={getSkeletonPercentageWidthByIndex(i)} />
            </Fragment>,
        );
    }

    return (
        <div className={className()} style={{ gridTemplateRows: `repeat(${skeletonCount}, var(--dropdown-menu-item-height))` }}>
            {skeletons}
        </div>
    );
};
